/**
 * 奖励&成就
 * auth：xuyan
 * time：2023-06-13 18:57
 */

import { useRef, useState, useEffect } from 'react';
import { Swiper, Toast } from 'antd-mobile';
import { SwiperRef } from 'antd-mobile/es/components/swiper';
import classnames from 'classnames';
import RewardTab from './Reward';
import Achievement from './Achievement';
import { NavBar } from '@/components/NavBar';
import AchieveShareImage from './ShareImg';
import { fetchReward } from '@/models/userState';
import { produce } from 'immer';
import {
  useRecoilState,
  useRecoilCallback,
  useRecoilValueLoadable,
  useSetRecoilState,
  useRecoilRefresher_UNSTABLE,
} from 'recoil';

import { HonorsInfoModel } from '@/models/typing';
import { Tracking } from '@/utils/tracking';
import './index.scss';
import { fetchHonorsInfoState, honorsInfoState } from '@/models/honorsState';
import ErrorPage from '@/components/Error';
import {DefaultLoadingPage} from '@/components/Loading';
import { useParams } from 'react-router-dom';

import html2canvas from 'html2canvas';
import { ShareText } from '@/utils/setting';
import { SpinLoading } from 'antd-mobile';

import './ShareImg.scss';

const HonorsPage = () => {
  const [activityInfo, setActiveInfo] = useRecoilState(honorsInfoState);

  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const [honorShare, setHonorShare] = useState('');
  const [isShow, setShow] = useState(false);
  const [isLoad, setLoad] = useState(false);

  const handleTabsChange = (key: any) => {
    setActiveIndex(key);
    swiperRef.current?.swipeTo(key);
  };

  const handleSwiperChange = (index: any) => {
    setActiveIndex(index);
  };

  const handleShare = (img: any) => {
    if (!img) return Toast.show({ content: '请选择成就图' });
    Tracking.UP('click_all_answer_glory_share_button');
    setShow(true);
    setLoad(true);
    //选中的图片
    setHonorShare(img);
    //随机文案
    setText(ShareText());

    getShareImageBase64()
      .then((res: any) => {
        setImgUrl(res);
        setLoad(false);
      })
      .catch((error) => {
        console.log('%cindex.tsx line:69 error', 'color: #007acc;', error);
      });
  };

  const onShareClose = () => {
    console.log('关闭弹窗');

    setShow(false);
  };

  const handleGetReward = useRecoilCallback(
    ({ snapshot }) =>
      async (list: any, index: number) => {
        if (list.status == 1) return;
        try {
          const res: any = await snapshot.getPromise(
            fetchReward(list.reward_bag_id)
          );

          if (res?.code == 100000) {
            Tracking.UP(`click_all_answer_glory_getReward${index * 1 + 1}`);
            //领奖成功
            setActiveInfo(
              produce(activityInfo, (draftState) => {
                draftState.reward_list[index].status = '1';
              })
            );
          }
          res && Toast.show({ content: res?.msg });
        } catch (error: any) {
          Toast.show({ content: error });
        }
      },
    [activityInfo]
  );

  const achievementOpt = {
    achieveList: activityInfo.achieve_list,
    handleShare: handleShare,
  };

  // const honorShareOption = {
  //   img: honorShare,
  //   isShow,
  //   onShareClose,
  // };

  const [imgUrl, setImgUrl] = useState('');
  const [sharetext, setText] = useState(ShareText());

  const getShareImageBase64 = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const imgDoc: any = document.querySelector('#shareImage');
        html2canvas(imgDoc, {
          useCORS: true,
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
          allowTaint: true,
          height: imgDoc.scrollHeight,
          windowHeight: imgDoc.scrollHeight,
          backgroundColor: '#0e0800',
        }).then((canvas: any) => {
          const imgData = canvas.toDataURL('image/jpeg', 1.0);
          resolve(imgData);
        });
      }, 300);
    });
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     let ss = document.querySelector('#shareImage');
  //     getShareImageBase64()
  //       .then((res: any) => {
  //         setImgUrl(res);
  //       })
  //       .catch((error) => {
  //         console.log('%cindex.tsx line:69 error', 'color: #007acc;', error);
  //       });
  //   });
  //   setText(ShareText());
  // }, []);

  const handleClose = () => {
    // props.onShareClose();
    setShow(false);
    setImgUrl('');
  };

  return (
    <div className='m-honor'>
      <div className='m-honor-wrap'>
        <NavBar backTitle='返回答题' />
        <div
          className={classnames(
            'm-honor__tabs',
            activeIndex == 0 && 'reward',
            activeIndex == 1 && 'achieve'
          )}
        >
          <div
            className='m-honor__tabs-tab'
            onClick={() => handleTabsChange(0)}
          ></div>
          <div
            className='m-honor__tabs-tab'
            onClick={() => handleTabsChange(1)}
          ></div>
        </div>
        <div className='m-honor-swiper'>
          <div>
            <Swiper
              direction='horizontal'
              loop
              indicator={() => null}
              ref={swiperRef}
              defaultIndex={activeIndex}
              onIndexChange={handleSwiperChange}
            >
              <Swiper.Item>
                <div className='content'>
                  {activeIndex == 0 && (
                    <RewardTab
                      rewardList={activityInfo.reward_list}
                      handleGetReward={handleGetReward}
                    />
                  )}
                </div>
              </Swiper.Item>
              <Swiper.Item>
                <div className='content'>
                  {activeIndex == 1 && <Achievement {...achievementOpt} />}
                </div>
              </Swiper.Item>
            </Swiper>
          </div>
        </div>
      </div>
      {/* 海报html */}
      {/* {isShow && <AchieveShareImage {...honorShareOption} />} */}
      <div className='achieve-share'>
        <div className='m-share share-canvas' id='shareImage'>
          <img
            className='share-canvas-logo'
            src={require('../../../assets/img/icon-colg.png')}
            alt=''
          />
          <div>
            <div className='m-share-achievePic'>
              <img src={honorShare} alt='' />
            </div>
            <div className='m-share-text'>
              <div className='text-left'>
                <div className='m-share-text__title'>COLG答题王活动</div>
                <div className='m-share-text__slogan'>{sharetext}</div>
              </div>
              <div className='img-qrcode'>
                <img
                  src='https://img-cos.colg.cn/uploads/image/colg_answer/bg_code/code.png/ori_png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>

        {/* {imgUrl && isShow && (
          <div>
            <div className='achieve-share-pop'>
              <SpinLoading />
              {imgUrl && (
                <div className='achieve-share-pop-wrap'>
                  <img className='shareCanvasImage' src={imgUrl} alt='' />
                  <div className='shareCanvasText'>长按保存图片分享</div>
                </div>
              )}
            </div>
            {imgUrl && (
              <>
                <img className='shareCanvasImageTop' src={imgUrl} alt='' />
                <div className='shareCanvasCancel' onClick={handleClose}></div>
              </>
            )}
          </div>
        )} */}

        {isShow && (
          <div>
            <div className='achieve-share-pop'>
              {isLoad && (
                <div className='achieve-share-pop-loading'>
                  <SpinLoading />
                </div>
              )}

              {imgUrl && (
                <div className='achieve-share-pop-wrap'>
                  <img className='shareCanvasImage' src={imgUrl} alt='' />
                  <div className='shareCanvasText'>长按保存图片分享</div>
                </div>
              )}
            </div>
            {imgUrl && (
              <>
                <img className='shareCanvasImageTop' src={imgUrl} alt='' />
                <div className='shareCanvasCancel' onClick={handleClose}></div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const MobileHonors = () => {
  const { id } = useParams();

  const setHonorsInfo = useSetRecoilState(honorsInfoState);

  const { state, contents } = useRecoilValueLoadable<HonorsInfoModel>(
    fetchHonorsInfoState(id ?? '')
  );

  const refresh = useRecoilRefresher_UNSTABLE(fetchHonorsInfoState(id ?? ''));

  useEffect(() => {
    if (state === 'hasValue') {
      setHonorsInfo(contents);
    }
  }, [state]);

  switch (state) {
    case 'hasValue':
      return <HonorsPage />;
    case 'hasError':
      return (
        <ErrorPage
          message={contents.message}
          onRetry={() => {
            refresh();
          }}
        />
      );
    case 'loading':
      return <DefaultLoadingPage />;
  }
};
